import axios from 'axios';
import { TokenService } from '@/plugins/token-service';
import { parseApiError } from '@/helpers/api-requests';

const actions = {
  async getProfile(store) {
    const { commit } = store;
    let link = '/v1/profile';
    link = `${link}?include=roles,permissions`;
    return await axios({
      url: link,
      method: 'GET',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          commit('resetPermissions');
          return Promise.reject(resp.data.error);
        }
        const data = resp.data.data;
        commit('setProfile', data);
        commit('setRoles', data);
        commit('resetPermissions');
        commit('setPermissions', data);
        return Promise.resolve(data);
      })
      .catch(resp => {
        commit('resetPermissions');
        return parseApiError(resp);
      });
  },
  setToken(store, token) {
    const { commit } = store;
    TokenService.setToken(token);
    axios.defaults.headers.common.Authorization = `bearer ${token}`;
    commit('setAccessToken', token);
  },
  setExpiryTokenDate(store, val) {
    const { commit } = store;
    val = Date.now() + val * 1000;
    TokenService.setExpireTokenDate(val);
    commit('setExpiryTokenDate', val);
  },
  logout(store) {
    return new Promise((resolve) => {
      const { commit } = store;
      axios.defaults.headers.common.Authorization = '';
      TokenService.removeToken();
      TokenService.removeExpireTokenDate();
      commit('logout');
      resolve();
    });
  },
  async uploadFile(store, {file, entityID, entityType, fileType, fileName, fileVersion}) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileable_id', entityID);
    formData.append('fileable_type', entityType);
    formData.append('type', fileType);
    if (!!fileName) formData.append('name', fileName);
    if (!!fileVersion) formData.append('version', fileVersion);
    return await axios({
      url: `/v1/files`,
      method: 'POST',
      headers: {
          'Content-Type': 'multipart/form-data'
      },
      data: formData,
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async replaceFile(store, { file, fileID, fileName, fileVersion }) {
    const formData = new FormData();
    if (!!file) formData.append('file', file);
    if (!!fileName) formData.append('name', fileName);
    if (!!fileVersion) formData.append('version', fileVersion);
    return await axios({
      url: `/v1/files/${fileID}`,
      method: 'POST',
      headers: {
          'Content-Type': 'multipart/form-data'
      },
      data: formData,
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async deleteFile(store, fileID) {
    return await axios({
      url: `/v1/files/${fileID}`,
      method: 'DELETE',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
};

export default actions;
